import { decliEntryPoint } from '@/helpers';

const context = require.context('./', true, /\.(js|ya?ml|json)$/);

export default decliEntryPoint(context);
